"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonDataGrid = void 0;
__exportStar(require("./grid"), exports);
__exportStar(require("./compat"), exports);
__exportStar(require("./GridHeader"), exports);
__exportStar(require("./GridFooter"), exports);
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const lu_1 = require("react-icons/lu");
function OktonDataGrid({ rows, columns, getRowId, loading = false, emptyMessage = 'Nenhum registro encontrado.', onRowClick, page = 1, pageSize = 20, total, pageSizeOptions = [10, 20, 30, 50, 100], onPageChange, onPageSizeChange, hidePagination = false, selectable = false, selectedIds = [], onSelectionChange, selectAllLabel = 'Selecionar todos', }) {
    const hoverBg = (0, react_1.useColorModeValue)('gray.50', 'gray.700');
    const headerBg = (0, react_1.useColorModeValue)('gray.50', 'gray.900');
    const borderColor = (0, react_1.useColorModeValue)('gray.200', 'gray.700');
    const selectedSet = react_2.default.useMemo(() => new Set(selectedIds.map(String)), [selectedIds]);
    const rowIds = react_2.default.useMemo(() => rows.map(row => getRowId(row)), [rows, getRowId]);
    const allVisibleSelected = rowIds.length > 0 && rowIds.every(id => selectedSet.has(String(id)));
    const someVisibleSelected = rowIds.some(id => selectedSet.has(String(id))) && !allVisibleSelected;
    const effectiveTotal = total !== null && total !== void 0 ? total : rows.length;
    const pageCount = Math.max(1, Math.ceil(effectiveTotal / pageSize));
    function toggleRow(id) {
        if (!onSelectionChange)
            return;
        const next = new Set(selectedSet);
        const key = String(id);
        if (next.has(key))
            next.delete(key);
        else
            next.add(key);
        const originalValues = [
            ...selectedIds.filter(value => next.has(String(value))),
            ...rowIds.filter(value => next.has(String(value)) &&
                !selectedIds.some(current => String(current) === String(value))),
        ];
        onSelectionChange(originalValues);
    }
    function toggleVisible() {
        if (!onSelectionChange)
            return;
        const next = new Set(selectedSet);
        if (allVisibleSelected) {
            rowIds.forEach(id => next.delete(String(id)));
        }
        else {
            rowIds.forEach(id => next.add(String(id)));
        }
        const byKey = new Map();
        selectedIds.forEach(id => byKey.set(String(id), id));
        rowIds.forEach(id => byKey.set(String(id), id));
        onSelectionChange(Array.from(next)
            .map(key => byKey.get(key))
            .filter((value) => value !== undefined));
    }
    return (react_2.default.createElement(react_1.Flex, { direction: "column", w: "100%", minW: 0 },
        react_2.default.createElement(react_1.Box, { overflowX: "auto", borderWidth: "1px", borderColor: borderColor, rounded: "xl" },
            react_2.default.createElement(react_1.Table, { size: "sm" },
                react_2.default.createElement(react_1.Thead, { bg: headerBg },
                    react_2.default.createElement(react_1.Tr, null,
                        selectable && (react_2.default.createElement(react_1.Th, { w: "44px", px: "3" },
                            react_2.default.createElement(react_1.Checkbox, { "aria-label": selectAllLabel, isChecked: allVisibleSelected, isIndeterminate: someVisibleSelected, onChange: toggleVisible }))),
                        columns.map(column => (react_2.default.createElement(react_1.Th, { key: column.key, w: column.width, textAlign: column.align || 'left' }, column.header))))),
                react_2.default.createElement(react_1.Tbody, null, loading ? (Array.from({ length: Math.min(5, pageSize) }).map((_, index) => (react_2.default.createElement(react_1.Tr, { key: index },
                    react_2.default.createElement(react_1.Td, { colSpan: columns.length + (selectable ? 1 : 0) },
                        react_2.default.createElement(react_1.Skeleton, { h: "32px", my: "2" })))))) : rows.length === 0 ? (react_2.default.createElement(react_1.Tr, null,
                    react_2.default.createElement(react_1.Td, { colSpan: columns.length + (selectable ? 1 : 0), py: "10", textAlign: "center" },
                        react_2.default.createElement(react_1.Text, { color: "gray.500" }, emptyMessage)))) : (rows.map((row, rowIndex) => {
                    const rowId = getRowId(row);
                    const selected = selectedSet.has(String(rowId));
                    return (react_2.default.createElement(react_1.Tr, { key: String(rowId), bg: selected ? hoverBg : undefined, cursor: onRowClick ? 'pointer' : 'default', _hover: { bg: hoverBg }, onClick: () => onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(row) },
                        selectable && (react_2.default.createElement(react_1.Td, { px: "3", onClick: event => event.stopPropagation() },
                            react_2.default.createElement(react_1.Checkbox, { "aria-label": `Selecionar linha ${rowId}`, isChecked: selected, onChange: () => toggleRow(rowId) }))),
                        columns.map(column => (react_2.default.createElement(react_1.Td, { key: column.key, textAlign: column.align || 'left' }, column.render
                            ? column.render(row, rowIndex)
                            : column.value
                                ? column.value(row)
                                : null)))));
                }))))),
        !hidePagination && (react_2.default.createElement(react_1.Flex, { mt: "3", gap: "3", align: "center", justify: "space-between", wrap: "wrap" },
            react_2.default.createElement(react_1.Text, { fontSize: "sm", color: "gray.500" },
                "Total: ",
                effectiveTotal),
            react_2.default.createElement(react_1.Flex, { align: "center", gap: "2", wrap: "wrap" },
                react_2.default.createElement(react_1.Text, { fontSize: "sm" }, "Linhas:"),
                react_2.default.createElement(react_1.Select, { size: "sm", w: "84px", value: pageSize, onChange: event => onPageSizeChange === null || onPageSizeChange === void 0 ? void 0 : onPageSizeChange(Number(event.target.value)) }, pageSizeOptions.map(option => (react_2.default.createElement("option", { key: option, value: option }, option)))),
                react_2.default.createElement(react_1.Text, { fontSize: "sm" },
                    page,
                    " de ",
                    pageCount),
                react_2.default.createElement(react_1.IconButton, { "aria-label": "Primeira p\u00E1gina", icon: react_2.default.createElement(lu_1.LuChevronsLeft), size: "sm", variant: "ghost", isDisabled: page <= 1, onClick: () => onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(1) }),
                react_2.default.createElement(react_1.IconButton, { "aria-label": "P\u00E1gina anterior", icon: react_2.default.createElement(lu_1.LuChevronLeft), size: "sm", variant: "ghost", isDisabled: page <= 1, onClick: () => onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(page - 1) }),
                react_2.default.createElement(react_1.IconButton, { "aria-label": "Pr\u00F3xima p\u00E1gina", icon: react_2.default.createElement(lu_1.LuChevronRight), size: "sm", variant: "ghost", isDisabled: page >= pageCount, onClick: () => onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(page + 1) }),
                react_2.default.createElement(react_1.IconButton, { "aria-label": "\u00DAltima p\u00E1gina", icon: react_2.default.createElement(lu_1.LuChevronsRight), size: "sm", variant: "ghost", isDisabled: page >= pageCount, onClick: () => onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(pageCount) }))))));
}
exports.OktonDataGrid = OktonDataGrid;
//# sourceMappingURL=index.js.map